import './App.css';
import Intro from './pages/intro/Intro';
import User from './pages/user/user';
import Home from './pages/home';
import Passport from './pages/passport';
import IdproofType from './pages/idproofType';
import Idproofback from './pages/idproofback';
import ProffAdress from './pages/proofAddress';
import ProffAdressnew from './pages/proofAddressnew';
import Recognition from './pages/Recognition';
import Liveness from './pages/Liveness';
import axios from "axios";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import React, { useRef, useEffect, useState,Component } from 'react';
import {BrowserRouter as Router , Route ,Routes } from 'react-router-dom';
import Donepage from './pages/done';

localStorage.setItem('userAgent', window.navigator.userAgent);
localStorage.setItem('brandlogo', 'https://res.cloudinary.com/hashfort/image/upload/v1682595042/logo/ictgvexi7nnzfe7sweff.png');
localStorage.setItem('brandname', '{brandname}');
localStorage.setItem('webtitle', 'Codego KYC');
localStorage.setItem('faviconUrl', 'https://res.cloudinary.com/durotechindustries-com-au/image/upload/v1724931624/codegofav_doqhae.ico');


function App() {
	const webtitle = localStorage.getItem('webtitle') || 'Default Title';
	const faviconUrl = localStorage.getItem('faviconUrl') || '%PUBLIC_URL%/favicon.ico';
  	const [state,setstatus]=React.useState(0);
	const [apierror,setapierror]=React.useState(0);
  	const [message,setmessage]=React.useState('');
	const senddata = async()=> {
		const queryParams = new URLSearchParams(window.location.search)
		let uuid = queryParams.get("uuid");

		if(uuid === undefined || uuid === null)
		{
			uuid = localStorage.getItem('uuid');
		}
		let data = JSON.stringify({
			"uuid": uuid,
		});
		let config = {
			method: 'POST',
			mode: 'cors',
			url: 'https://kyc2.codegotech.com/chcekuuid',
			headers: {
				'Content-Type': 'application/json',
			},
			data : data
		};
		await axios.request(config)
		.then((response) => {

			if(response.status == 200)
			{
				if(response.data.status == 1)
				{
					localStorage.setItem('isIdCard', response.data.is_idcard);
					localStorage.setItem('isalreadycheck', response.data.is_already_check);
					localStorage.setItem('brandlogo', response.data.brandlogo);
					localStorage.setItem('brandname', response.data.brandname);
					localStorage.setItem('kyctype', response.data.type);
					localStorage.setItem('uuid', uuid);
					setstatus(response.data.status);
					if(response.data.type == 'partial')
					{
						if(response.data.liveness === 1)
						{
							localStorage.setItem('comImage',  response.data.comImage);
							localStorage.setItem('partial_page', 'LIVENESS');
						}else if(response.data.id_proof === 1)
						{
							localStorage.setItem('partial_page', 'ID');
						}else if(response.data.address_proof === 1)
						{
							localStorage.setItem('partial_page', 'ADDRESS');

						}
					}else{
						localStorage.setItem('address_proof', response.data.address_proof);
					}
				}else{
					setstatus(response.data.status);
					setmessage(response.data.message);
				}
			}else{
				setstatus(0);
				setmessage('unauthorized access');
			}

		}).catch((error) => {
			console.log(error);
		});

	}
	const uuid = localStorage.getItem('uuid');
  	const brandlogo = localStorage.getItem('brandlogo');
	let qruurl = 'https://api.qrserver.com/v1/create-qr-code/?size=170x170&data=https://kyc.codegotech.com/?uuid='+uuid+'&choe=UTF-8&chld=L';

	useEffect(() => {
        document.title = webtitle;
		const favicon = document.getElementById('favicon');
        if (favicon) {
            favicon.href = faviconUrl;
        }
        senddata();
    }, [webtitle, faviconUrl]);

  return (
    <div className="App">

    {isMobile == true ?

    state == 1 ?
    <MobileView>
      { <Router>
        <Routes>
        <Route path='/' element={<Intro />} />
		<Route path='/kycalready' element={<User />} />
		<Route path='/personal' element={<Home />} />
		<Route path='/idprooftype' element={<IdproofType />} />
		<Route path='/Passport' element={<Passport />} />
		<Route path='/idproofback' element={<Idproofback />} />
		<Route path='/proof' element={<ProffAdress />} />
		<Route path='/proofnew' element={<ProffAdressnew />} />
		<Route path='/recognition' element={<Recognition />} />
		<Route path='/liveness' element={<Liveness />} />
		<Route path='/process' element={<Donepage />} />
        </Routes>
      </Router>  }
    </MobileView>
    : <div className="kyc-browser-warn">
        <div className="kyc-browser-warn__card">
          <div className="kyc-browser-warn__icon">
            <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </div>
          <h2 style={{ fontSize: 18, margin: '0 0 8px', fontWeight: 700 }}>Verification unavailable</h2>
          <p style={{ fontSize: 14, color: 'var(--kyc-text-secondary)', margin: 0 }}>{message}</p>
        </div>
      </div>
    :
    <BrowserView>
      <div className="kyc-shell">
        <header className="kyc-header">
          <img src={brandlogo} alt="Brand" className="kyc-header__logo" />
        </header>
        <main className="kyc-main">
          <div className="kyc-container">
            {state == 1 ? (
              <div className="kyc-card" style={{ textAlign: 'center', alignItems: 'center' }}>
                <div className="kyc-card__eyebrow">Identity Verification</div>
                <h2 className="kyc-card__title">Continue on your mobile phone</h2>
                <p className="kyc-card__subtitle">
                  Scan the QR code below with your mobile device. Verification
                  is faster and more reliable on a phone camera.
                </p>
                <div className="kyc-qr">
                  <img src={qruurl} alt="QR code" />
                  <p style={{ fontSize: 12, color: 'var(--kyc-text-muted)', margin: 0 }}>
                    Point your camera at the QR code
                  </p>
                </div>
              </div>
            ) : (
              <div className="kyc-card" style={{ textAlign: 'center', alignItems: 'center' }}>
                <div className="kyc-browser-warn__icon">
                  <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </div>
                <h2 className="kyc-card__title">Verification unavailable</h2>
                <p className="kyc-card__subtitle">{message}</p>
              </div>
            )}
          </div>
        </main>
      </div>
    </BrowserView>
    }
  </div>

  );
}

export default App;
